import { SvgIconProps } from '@material-ui/core';
import { FC, forwardRef } from 'react';
import { ReactComponent as ConstructionOrangeIconSvg } from './constructionOrangeIconSvg.svg';
import { ReactComponent as WirelessOrangeIconSvg } from './WirelessOrangeIconSvg.svg';
import { ReactComponent as EnergyOrangeIconSvg } from './EnergyOrangeIconSvg.svg';
import { ReactComponent as EngineeringOrangeIconSvg } from './EngineeringOrangeIconSvg.svg';
import { ReactComponent as TechnologyDeploymentOrangeIconSvg } from './TechnologyDeploymentOrangeIconSvg.svg';
import { ReactComponent as WaterServiceIconSvg } from './waterServiceIcon.svg';
import { ReactComponent as ConsultingBusinessServicesIconSvg } from './ConsultingBusinessServicesIcon.svg';
import { ReactComponent as FulfillmentServicesIconSvg } from './FulfillmentServicesIconSvg.svg';
import { ReactComponent as ArrowWhiteIconSvg } from './arrowWhite.svg';
import { ReactComponent as DataServicesIconSvg } from './DataServicesIconSvg.svg';
import { ReactComponent as SmallWhiteArrowIconSvg } from './smallWhiteArrow.svg';
import { ReactComponent as WirelineIconSvg } from './WirelineIconSvg.svg';
import { ReactComponent as WirelineSecondIconSvg } from './WirelineSecondIconSvg.svg';
import { ReactComponent as WirelineExpertiseIconSvg } from './wirelineExpertiseIconSvg.svg';
import { ReactComponent as PowerDeliveryIconSvg } from './powerDeliveryIconSvg.svg';
import { ReactComponent as OilGasIconSvg } from './oilGasIconSvg.svg';

export const ConstructionOrangeIcon: FC<SvgIconProps> = forwardRef((props, ref) => (
  <ConstructionOrangeIconSvg ref={ref} {...props} />
));
export const WirelessOrangeIcon: FC<SvgIconProps> = forwardRef((props, ref) => <WirelessOrangeIconSvg ref={ref} {...props} />);
export const EnergyOrangeIcon: FC<SvgIconProps> = forwardRef((props, ref) => <EnergyOrangeIconSvg ref={ref} {...props} />);
export const EngineeringOrangeIcon: FC<SvgIconProps> = forwardRef((props, ref) => (
  <EngineeringOrangeIconSvg ref={ref} {...props} />
));
export const TechnologyDeploymentOrangeIcon: FC<SvgIconProps> = forwardRef((props, ref) => (
  <TechnologyDeploymentOrangeIconSvg ref={ref} {...props} />
));
export const WaterServiceIcon: FC<SvgIconProps> = forwardRef((props, ref) => <WaterServiceIconSvg ref={ref} {...props} />);

export const ConsultingBusinessServicesIcon: FC<SvgIconProps> = forwardRef((props, ref) => (
  <ConsultingBusinessServicesIconSvg ref={ref} {...props} />
));

export const FulfillmentServicesIcon: FC<SvgIconProps> = forwardRef((props, ref) => (
  <FulfillmentServicesIconSvg ref={ref} {...props} />
));

export const ArrowWhiteIcon: FC<SvgIconProps> = forwardRef((props, ref) => <ArrowWhiteIconSvg ref={ref} {...props} />);

export const DataServicesIcon: FC<SvgIconProps> = forwardRef((props, ref) => (
  <DataServicesIconSvg ref={ref} {...props} />
));

export const SmallWhiteArrowIcon: FC<SvgIconProps> = forwardRef((props, ref) => (
  <SmallWhiteArrowIconSvg ref={ref} {...props} />
));

export const WirelineIcon: FC<SvgIconProps> = forwardRef((props, ref) => (
  <WirelineIconSvg ref={ref} {...props} />
));

export const WirelineSecondIcon: FC<SvgIconProps> = forwardRef((props, ref) => (
  <WirelineSecondIconSvg ref={ref} {...props} />
));

export const WirelineExpertiseIcon: FC<SvgIconProps> = forwardRef((props, ref) => (
  <WirelineExpertiseIconSvg ref={ref} {...props} />
));

export const PowerDeliveryIcon: FC<SvgIconProps> = forwardRef((props, ref) => (
  <PowerDeliveryIconSvg ref={ref} {...props} />
));

export const OilGasIcon: FC<SvgIconProps> = forwardRef((props, ref) => (
  <OilGasIconSvg ref={ref} {...props} />
));
